import { CommissionEchantillonOperateurEdition } from './commission-echantillon-operateur-edition.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class CommissionEchantillonEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        numero: { key: 'numero', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        numeroAnonymat: { key: 'numeroAnonymat', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' },
        campagne: { key: 'campagne', optional: true, default: '' },
        cahier: { key: 'cahier', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        millesime: { key: 'millesime', optional: true, default: '' },
        numeroJury: { key: 'numeroJury', optional: true, default: '' },
        datePrelevement: { key: 'datePrelevement', optional: true, default: '' },
        volume: { key: 'volume', optional: true, default: '' },
        estConforme: { key: 'estConforme', optional: true, default: '' },
        motifNonConformite: { key: 'motifNonConformite', optional: true, default: '' },
        observation: { key: 'observation', optional: true, default: '' },
        passage: { key: 'passage', optional: true, default: '' },
        expertise: { key: 'expertise', optional: true, default: '' },
        cepages: { key: 'cepages', optional: true, default: '' },
        typeEchantillon: { key: 'typeEchantillon', optional: true, default: '' },
        resultatAnalytique: { key: 'resultatAnalytique', optional: true, default: '' },
        resultatOrganoleptique: { key: 'resultatOrganoleptique', optional: true, default: '' },
        defauts: { key: 'defauts', optional: true, default: '' },
        gravite: { key: 'gravite', optional: true, default: '' },
        operateur: { key: 'operateur', converter: new (ClassConverterFactory.build(CommissionEchantillonOperateurEdition))(), optional: true }
    };

    id: number;
    numero: string;
    numeroLot: string;
    numeroDossier: string;
    numeroAnonymat: string;
    logement: string;
    campagne: string;
    cahier: string;
    produit: string;
    millesime: string;
    numeroJury: string;
    datePrelevement: string;
    volume: string;
    estConforme: string;
    motifNonConformite: string;
    observation: string;
    passage: string;
    expertise: string;
    cepages: string;
    typeEchantillon: string;
    resultatAnalytique: string;
    resultatOrganoleptique: string;
    defauts: string;
    gravite: string;
    operateur: CommissionEchantillonOperateurEdition;
}
